
import {pagesRoutes as AccountRoute} from '../pages/Account/index'
import {pagesRoutes as SqlReportRoute} from '../pages/SqlReport/index'
import {pagesRoutes as DefaultRoute} from '../pages/Default/index'
import {CustomRoutePre, CustomRoutePost, SuppressGenRoute} from '../pages/CustomRoute'
/* all these are dynamic, add the required route for each page */
import {pagesRoutes as RBtnTrackingRoute} from '../pages/RBtnTracking/index'
import {pagesRoutes as VwRUsrButtonTrackingRoute} from '../pages/VwRUsrButtonTracking/index'
import {pagesRoutes as RSignUpSurveyRoute} from '../pages/RSignUpSurvey/index'
import {pagesRoutes as VwRUsrSignUpSurveyRoute} from '../pages/VwRUsrSignUpSurvey/index'
import {pagesRoutes as SubTestRoute} from '../pages/SubTest/index'
import {pagesRoutes as VwRUsrSubDtlRoute} from '../pages/VwRUsrSubDtl/index'
export default [
...(CustomRoutePre || []),
...(
SuppressGenRoute ? [] : [
...AccountRoute,
...DefaultRoute,
// ...SqlReportRoute,
]
),
...(
SuppressGenRoute ? [] : [
...RBtnTrackingRoute,
...VwRUsrButtonTrackingRoute,
...RSignUpSurveyRoute,
...VwRUsrSignUpSurveyRoute,
...SubTestRoute,
...VwRUsrSubDtlRoute,
]),
...(CustomRoutePost || []),
];

 document.Rintagi.systemId = '17';


// WEBPACK FOOTER //
// ./src/app/route.js